import { render, staticRenderFns } from "./ProfileFormFields.vue?vue&type=template&id=20e329a4"
import script from "./ProfileFormFields.vue?vue&type=script&lang=ts"
export * from "./ProfileFormFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports